import React, { useState, useEffect } from "react";
import DeleteIcon from "../../../assets/svg/deletebtn.svg";
import EditIcon from "../../../assets/svg/editbtn.svg";
import { GetUserAddresses, DeleteUserAddress, AddUserAddress, UpdateUserAddress } from "../../../Services/AddressService";
import CreateAddressPopup from "../AccountSetting/CreateAddressPopup";
import DeleteConfirmModal from "../AccountSetting/DeleteConfirmModal";

const ManageAddress = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);

  const fetchAddresses = async () => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      setLoading(false);
      return;
    }

    try {
      const response = await GetUserAddresses({ userId });

      // SAFETY CHECK
      const list = response?.data?.data || response?.data || [];

      setAddresses(list);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);


  const handleSaveAddress = async (formData) => {
    const userId = localStorage.getItem("userId");
    const email = localStorage.getItem("email");

    const payload = {
      ...formData,
      userId,
      email: email,
    };

    try {
      let response;
      if (editingAddress) {
        // Update existing address
        response = await UpdateUserAddress(editingAddress.id, payload);
      } else {
        // Add new address
        response = await AddUserAddress(payload);
      }

      if (response.status) {
        await fetchAddresses();
        setEditingAddress(null); // Reset editing state
        return true; // Success → popup close
      } else {
        alert(`Failed to ${editingAddress ? 'update' : 'add'} address: ` + response.message);
        return false;
      }
    } catch (error) {
      console.error(`Error ${editingAddress ? 'updating' : 'adding'} address:`, error);
      alert(`Something went wrong while ${editingAddress ? 'updating' : 'saving'} address.`);
      return false;
    }
  };

  const handleEditAddress = (address) => {
    setEditingAddress(address);
    setShowPopup(true);
  };

  const handleDeleteAddress = (address) => {
    setAddressToDelete(address);
    setShowDeleteModal(true);
  };

  const confirmDeleteAddress = async () => {
    if (addressToDelete) {
      try {
        await DeleteUserAddress(addressToDelete.id);
        setAddresses(addresses.filter(addr => addr.id !== addressToDelete.id));
        setShowDeleteModal(false);
        setAddressToDelete(null);
      } catch (error) {
        console.error("Error deleting address:", error);
      }
    }
  };


  if (loading) return <div>Loading...</div>;


  return (
    <>
      <div className="main-content">
        <div>
          <h3 className="fs_16 pb_28 mb-0 text-black fw_500">
            Default Address
          </h3>
        </div>

        <div className="address-list" style={{ maxHeight: "450px", overflowY: "scroll" }}>
          {addresses.map((address) => (
            <div key={address.id} className="list-grid d-flex justify-content-between align-items-start">

              <div className="d-flex align-items-start">
                <div>
                  <div className="d-flex align-items-center gap-3 mb_8">
                    <h5 className="fs_16 fw_400 text-color">
                      {address.firstName} {address.lastName}
                    </h5>
                    <span className="tag fs_12 fw_500 lh-1">{address.addressTypeName}</span>
                  </div>

                  <p className="fs_14 fw_400 lh-1 text-color mb_12">
                    {address.address1}, {address.cityName}, {address.stateName} {address.zipPostalCode}
                  </p>
                  <p className="fs_14 fw_400 lh-1 text-color mb_12">
                    Mobile : <span className="fw_700">{address.phoneNumber}</span>
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-center action-icon">
                <div
                  className="text-black fs_14 fw_500 text-uppercase mr_28 text-no-wrap"
                  onClick={() => handleDeleteAddress(address)}
                  style={{ cursor: "pointer" }}
                >
                  <img className="img-fluid mr_10" src={DeleteIcon} alt="delete icon" />
                  Remove
                </div>

                <div
                  className="text-black fs_14 fw_500 text-uppercase text-no-wrap"
                  onClick={() => handleEditAddress(address)}
                  style={{ cursor: "pointer" }}
                >
                  <img className="img-fluid mr_10" src={EditIcon} alt="edit icon" />
                  Edit
                </div>
              </div>

            </div>
          ))}

          <button className="add-new" onClick={() => setShowPopup(true)}>
            + Add New Address
          </button>
        </div>
      </div>


      {/* Address Popup */}
      {showPopup && (
        <CreateAddressPopup
          onClose={() => {
            setShowPopup(false);
            setEditingAddress(null);
          }}
          onSave={handleSaveAddress}
          editingAddress={editingAddress}
        />
      )}

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setAddressToDelete(null);
        }}
        onConfirm={confirmDeleteAddress}
        itemName="address"
      />
    </>
  );
};

export default ManageAddress;
